import { AddressModel } from "@globals/openapi-models/model/addressModel";
import { CustomerCriticalAddressDto } from "@globals/openapi-models/model/customerCriticalAddressDto";
import { EnrollmentAddressReadModel } from "@globals/openapi-models/model/enrollmentAddressReadModel";
import { EntryAddressSelectionDto } from "@globals/openapi-models/model/entryAddressSelectionDto";
import { EntryAddressStatusDetails } from "@globals/openapi-models/model/entryAddressStatusDetails";
import { MapEntryAddressStatusDto } from "@globals/openapi-models/model/mapEntryAddressStatusDto";
import { SendToAddressItem } from "@globals/openapi-models/model/sendToAddressItem";
import { BiMapComponentAddressModel } from "./BiMapComponentAddressModel";

export class BiMapComponentAddressModelFactory {
  public static constructByEntryAddressStatusDetails(addressModel: EntryAddressStatusDetails): BiMapComponentAddressModel {
    return <BiMapComponentAddressModel>{
      zipcode: addressModel.zipcode,
      zipCodeFormatted: addressModel.zipcodeFormatted,
      city: addressModel.city,
      street: addressModel.street,
      number: addressModel.number,
      letter: addressModel.letter,
      meters: addressModel.meters,
      kvhx: addressModel.kvhx,
      phoneCode: addressModel.phoneCode,
      email: addressModel.email,
      personName: addressModel.personName,
      locationName: null,
      phoneNumber: addressModel.phoneNumber,
      hasPhoneNumber: addressModel.hasPhoneNumber,
      displayValue: null,
      latitude: null,
      longitude: null,
      status: addressModel.statusMessage
    };
  }

  public static constructByAddressModel(addressModel: AddressModel): BiMapComponentAddressModel {
    return <BiMapComponentAddressModel>{
      zipcode: addressModel.zipCode,
      zipCodeFormatted: addressModel.zipCodeFormatted,
      city: addressModel.city,
      street: addressModel.street,
      number: addressModel.number,
      letter: addressModel.letter,
      floor: addressModel.floor,
      door: addressModel.door,
      meters: addressModel.meters,
      kvhx: addressModel.kvhx,
      kvh: addressModel.kvh,
      displayValue: addressModel.displayValue,
      latitude: addressModel.latitude,
      longitude: addressModel.longitude,
      phoneCode: addressModel.phoneCode,
      email: addressModel.email,
      personName: addressModel.name,
      numberOfFloorDoors: addressModel.numberOfFloorDoors,
      isCriticalAddress: addressModel.isCriticalAddress,
      locationName: addressModel.locationName,
      phoneNumber: addressModel.phone,
      hasPhoneNumber: addressModel.hasPhoneNumber,
      isSubscription: addressModel.subscriptionId || addressModel.enrollmentId ? true : false
    };
  }

  public static constructBySendToAddressItem(addressItem: SendToAddressItem): BiMapComponentAddressModel {
    return <BiMapComponentAddressModel>{
      zipcode: addressItem.zipCode,
      zipCodeFormatted: addressItem.zipCodeFormatted,
      city: addressItem.city,
      street: addressItem.street,
      number: addressItem.fromNumber,
      letter: addressItem.letter,
      floor: addressItem.floor,
      door: addressItem.door,
      meters: addressItem.meters,
      kvhx: addressItem.kvhx,
      kvh: addressItem.kvh,
      displayValue: addressItem.displayValue,
      latitude: addressItem.latitude,
      longitude: addressItem.longitude,
      phoneCode: addressItem.phoneCode,
      email: addressItem.email,
      personName: addressItem.name,
      numberOfFloorDoors: addressItem.numberOfFloorDoors,
      isCriticalAddress: addressItem.isCriticalAddress,
      phoneNumber: addressItem.phoneNumber,
      hasPhoneNumber: addressItem.phoneNumber != undefined,
      geo: addressItem.geo
    };
  }

  public static constructByMapEntryAddressDto(mapEntryAddress: EntryAddressSelectionDto): BiMapComponentAddressModel {
    return <BiMapComponentAddressModel>{
      zipcode: mapEntryAddress.zipcode,
      city: mapEntryAddress.city,
      street: mapEntryAddress.street,
      number: mapEntryAddress.number,
      letter: mapEntryAddress.letter,
      meters: mapEntryAddress.meters,
      kvh: mapEntryAddress.kvh,
      displayValue: mapEntryAddress.displayValue,
      latitude: mapEntryAddress.latitude,
      longitude: mapEntryAddress.longitude,
      numberOfFloorDoors: mapEntryAddress.numberOfFloorDoors,
      isCriticalAddress: mapEntryAddress.isCriticalAddress,
      countryId: mapEntryAddress.countryId,
      geo: mapEntryAddress.geo,
      hasPhoneNumber: mapEntryAddress.hasPhonenumber
    };
  }

  public static constructByMapEntryAddressSelectionDto(mapSelectionAddress: EntryAddressSelectionDto): BiMapComponentAddressModel {
    return {
      ...BiMapComponentAddressModelFactory.constructByMapEntryAddressDto(mapSelectionAddress),
      hasPhoneNumber: mapSelectionAddress.hasPhonenumber,
      displayValue: mapSelectionAddress.displayValue,
      geo: mapSelectionAddress.geo
    };
  }

  public static constructByMapEntryAddressStatusDto(mapAddress: MapEntryAddressStatusDto, smsGroupId: number): BiMapComponentAddressModel {
    const model = BiMapComponentAddressModelFactory.constructByMapEntryAddressDto(mapAddress);
    model.smsGroupId = smsGroupId;
    model.status = mapAddress.status;
    model.statusTypeId = mapAddress.statusTypeId;
    model.isDelivered = mapAddress.isDelivered;

    return model;
  }

  public static constructByEnrollmentAddress(enrollmentAddress: EnrollmentAddressReadModel): BiMapComponentAddressModel {
    return <BiMapComponentAddressModel>{
      zipcode: enrollmentAddress.zipcode,
      zipCodeFormatted: enrollmentAddress.zipcode.toString(),
      city: enrollmentAddress.city,
      street: enrollmentAddress.street,
      number: enrollmentAddress.number,
      letter: enrollmentAddress.letter,
      meters: enrollmentAddress.meters,
      locationName: enrollmentAddress.locationName,
      displayValue: undefined,
      latitude: enrollmentAddress.latitude,
      longitude: enrollmentAddress.longitude
    };
  }

  public static constructByCustomerCriticalAddressDto(a: CustomerCriticalAddressDto): BiMapComponentAddressModel {
    return <BiMapComponentAddressModel>{
      kvhx: a.kvhx,
      displayValue: a.addressFormatted + (a.industryCodeFormatted ? `<br/><br/> ${a.industryCodeFormatted}` : ""),
      latitude: a.latitude,
      longitude: a.longitude
    };
  }
}
